import { render, staticRenderFns } from "./IpoDocsWave.vue?vue&type=template&id=79cc9128&scoped=true"
import script from "./IpoDocsWave.vue?vue&type=script&lang=js"
export * from "./IpoDocsWave.vue?vue&type=script&lang=js"
import style0 from "./IpoDocsWave.vue?vue&type=style&index=0&id=79cc9128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc9128",
  null
  
)

export default component.exports